export default __webpack_public_path__ + "media/images/to-app-store-100-fr-2f538f2360e76e6bcbfd4045917da7e0.png";